import React, { createContext, useReducer, useContext } from 'react';

export interface HeaderState {
  isShowSavedProduct: boolean;
}
export type HeaderAction = { type: 'showSavedProduct' } | { type: 'hideSavedProduct' };
// INITIAL STATE
const initialState = {
  isShowSavedProduct: false
};

// REDUCER
const headerReducer = (state: HeaderState, action: HeaderAction) => {
  switch (action.type) {
    case 'showSavedProduct':
      return { ...state, isShowSavedProduct: true };
    case 'hideSavedProduct':
      return {
        ...state,
        isShowSavedProduct: false
      };
    default:
      return state;
  }
};

// THE CONTEXT
const HeaderContext = createContext<
  { state: HeaderState; dispatch: React.Dispatch<HeaderAction> } | undefined
>(undefined);

// THE PROVIDER COMPONENT
export const HeaderProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const [state, dispatch] = useReducer(headerReducer, initialState);

  return <HeaderContext.Provider value={{ state, dispatch }}>{children}</HeaderContext.Provider>;
};

// THE CUSTOM HOOK.
export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
